import { useCallback } from 'react';

export function useHeaderScrollToTop(scrollRef: React.RefObject<HTMLElement | null>) {
  return useCallback(() => {
    scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [scrollRef]);
}
